var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46575 11.2931C9.59875 10.1601 11.5747 10.1601 12.7078 11.2931L13.4147 12.0001L14.8288 10.5861L14.1217 9.87906C13.1788 8.93506 11.9228 8.41406 10.5868 8.41406C9.25075 8.41406 7.99475 8.93506 7.05175 9.87906L4.92975 12.0001C2.98175 13.9491 2.98175 17.1221 4.92975 19.0711C5.90475 20.0461 7.18475 20.5331 8.46475 20.5331C9.74575 20.5331 11.0267 20.0461 12.0007 19.0711L12.7078 18.3641L11.2938 16.9501L10.5868 17.6571C9.41675 18.8241 7.51375 18.8261 6.34375 17.6571C5.17475 16.4871 5.17475 14.5841 6.34375 13.4141L8.46575 11.2931Z",
    fill: "#C10037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 4.92892L11.2929 5.63592L12.7069 7.04992L13.4139 6.34292C14.5829 5.17592 16.4859 5.17392 17.6569 6.34292C18.8259 7.51292 18.8259 9.41592 17.6569 10.5859L15.5349 12.7069C14.4019 13.8399 12.4259 13.8399 11.2929 12.7069L10.5859 11.9999L9.17188 13.4139L9.87887 14.1209C10.8219 15.0649 12.0779 15.5859 13.4139 15.5859C14.7499 15.5859 16.0059 15.0649 16.9489 14.1209L19.0709 11.9999C21.0189 10.0509 21.0189 6.87792 19.0709 4.92892C17.1209 2.97892 13.9479 2.97992 11.9999 4.92892Z",
    fill: "#C10037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.61d7a5faaef0d54eb648b964a446172d.svg";
export { ForwardRef as ReactComponent };